<div id="main" (click)="resetTimeCounter()" (mousemove)="resetTimeCounter()" (keypress)="resetTimeCounter()">
    <div id="header">
        <i aria-hidden="true" class="toggle-menu fa fa-bars" (click)="toggleClick()" *ngIf="!isApplicant"></i>
        <i aria-hidden="true" *ngIf="isApplicant" style="margin-left: 20px"></i>
        <div class="logo-container mr-2"></div>
        <span class="badge badge-dark" style="color: #fff" *ngIf="displayEnvironmentName">
            <span>{{environment?.mode | uppercase }}</span>
        </span>
        <div class="flex-1"></div>
        <span class="text-white ml-2 d-flex align-items-center" style="cursor: pointer;gap: 15px;" (click)="goToMyAccount()" *ngIf="!isApplicant">
            <mat-icon>person</mat-icon>
            <span>{{username}}</span>
        </span>
        <div *ngIf="unavailabilityScheduleIsEnabled && hasAvailabilityToggleViewPermission" class="d-flex align-items-center" style="margin-left: 15px;">
                <mat-slide-toggle 
                    [checked]="(availability$ | async)!"
                    (change)="toggleUserAvailability($event)">
                </mat-slide-toggle>
                <span style="margin-left: 15px;">{{userFormState}}</span>
        </div>
        <button class="btn btn-link text-white text-white ml-1" (click)="signOut()" *ngIf="!isApplicant">
            <i aria-hidden="true" class="fa fa-sign-out-alt"></i>
            <span>Sign Out</span>
        </button>
        <span *ngIf="isPurlV2Active" class="m-2">
            <mat-icon svgIcon="logout" aria-label="Exit Application" style="color: #900606; cursor: pointer"
                (click)="exitApplication()" class="mat-icon-red"></mat-icon>
        </span>
    </div>
    <div id="body" class="flex-fill">
        <div id="sidenav" style="height:100%;display:flex;flex-direction: column" class="custom-scrollbar" [ngClass]="{'hidenav': !showSideNav }" *ngIf="!isApplicant">
            <div *ngFor="let item of menu" (click)="selectMenu($event, item)" [ngClass]="{'active': activeMenu == item.title}">
                <div class="menu-item" *ngIf="item.hasAccess" [class.disabled]="item.disabled">
                    <div class="menu-item-content">
                        <i aria-hidden="true" class="menu-item-icon fa {{item.icon}}"></i>
                        <span class="menu-item-title">{{item.title}}</span>
                    </div>
                </div>
            </div>
            <div style="flex-grow: 1">
                
            </div>
            <div *ngIf="isMyAccountEnabled && hasMyAccountViewPermission" class="menu-item">
                <div class="menu-item-content">
                    <i aria-hidden="true" class="menu-item-icon fa fa fa-user"></i>
                    <span (click)="goToMyAccount()" class="menu-item-title">My Account</span>
                </div>
            </div>
            <div class="menu-item">
                <div class="menu-item-content">
                    <i aria-hidden="true" class="menu-item-icon fa fa-right-from-bracket"></i>
                    <span (click)="signOut()" class="menu-item-title">Sign Out</span>
                </div>
            </div>
        </div>
        <router-outlet style="display: none;"></router-outlet>
    </div>
</div>